// src/data/day1_btcusd_ohlc.js
export const day1BtcUsdOhlc = [
    // Visible (22)
    { time: '2024-06-01', open: 66200, high: 66500, low: 66000, close: 66400 },
    { time: '2024-06-02', open: 66400, high: 66800, low: 66250, close: 66650 },
    { time: '2024-06-03', open: 66650, high: 67250, low: 66500, close: 67100 },
    { time: '2024-06-04', open: 67100, high: 67350, low: 66600, close: 66750 },
    { time: '2024-06-05', open: 66750, high: 66900, low: 66100, close: 66250 },
    { time: '2024-06-06', open: 66250, high: 66600, low: 66050, close: 66550 },
    { time: '2024-06-07', open: 66550, high: 67050, low: 66400, close: 66950 },
    { time: '2024-06-08', open: 66950, high: 67650, low: 66800, close: 67550 },
    { time: '2024-06-09', open: 67550, high: 67800, low: 67150, close: 67200 },
    { time: '2024-06-10', open: 67200, high: 67450, low: 66850, close: 66900 },
    { time: '2024-06-11', open: 66900, high: 67100, low: 66550, close: 66650 },
    { time: '2024-06-12', open: 66650, high: 67000, low: 66400, close: 66950 },
    { time: '2024-06-13', open: 66950, high: 67600, low: 66800, close: 67300 },
    { time: '2024-06-14', open: 67300, high: 67950, low: 67200, close: 67850 },
    { time: '2024-06-15', open: 67850, high: 68150, low: 67600, close: 67950 },
    { time: '2024-06-16', open: 67950, high: 68200, low: 67550, close: 67750 },
    { time: '2024-06-17', open: 67750, high: 68150, low: 67500, close: 68050 },
    { time: '2024-06-18', open: 68050, high: 68350, low: 67900, close: 68250 },
    { time: '2024-06-19', open: 68250, high: 68650, low: 68100, close: 68550 },
    { time: '2024-06-20', open: 68550, high: 68950, low: 68400, close: 68850 },
    { time: '2024-06-21', open: 68850, high: 69250, low: 68650, close: 69100 },
    { time: '2024-06-22', open: 69100, high: 69350, low: 68950, close: 69000 },
  
    // Outcome (8) — reveals continuation → small pullback → continuation
    { time: '2024-06-23', open: 69000, high: 69550, low: 68900, close: 69450 },
    { time: '2024-06-24', open: 69450, high: 69950, low: 69300, close: 69800 },
    { time: '2024-06-25', open: 69800, high: 70100, low: 69600, close: 69900 },
    { time: '2024-06-26', open: 69900, high: 70150, low: 69500, close: 69600 },
    { time: '2024-06-27', open: 69600, high: 69750, low: 69100, close: 69250 },
    { time: '2024-06-28', open: 69250, high: 69700, low: 69050, close: 69650 },
    { time: '2024-06-29', open: 69650, high: 70350, low: 69550, close: 70250 },
    { time: '2024-06-30', open: 70250, high: 70750, low: 70150, close: 70600 },
  ];
  